import { IFormatObjectEditable } from "../IFormatObjectEditable";
import { IFormatSpecification } from "../IFormatSpecification";
import { IImageObject } from "../objects";
import { AbstractImageDrawableObjectEditor } from "./AbstractImageDrawableObjectEditor";

export class ImageObjectEditor extends AbstractImageDrawableObjectEditor<IImageObject> {
  constructor(source: IImageObject | ImageObjectEditor, specification?: IFormatSpecification, isNew: boolean = false) {
    super(source, specification, isNew);
  }

  isAspectRatioFixed(): boolean {
    return  this.imageContent().getValue().isEnable || this.temporaryImageContent().getValue().isEnable;
  }

  getTypeName(): string {
    return "画像";
  }

  clone(): IFormatObjectEditable {
    return new ImageObjectEditor(this);
  }
}
